// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1126":"3c2098d722c73e69","3558":"04fe4015436d0083","6775":"1dcfd85036700d60"}[chunkId] + ".js";
};